import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import Map from 'ol/Map';
import Feature from 'ol/Feature';
import View from 'ol/View';
import {Geometry, Point,Polygon} from 'ol/geom';
import {Style,Fill, Stroke} from 'ol/style';
import Icon from 'ol/style/Icon';
import OSM from 'ol/source/OSM';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import Overlay from 'ol/Overlay';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import * as olExtent from 'ol/extent';
import * as olProj from 'ol/proj';
import Attribution from 'ol/control/Attribution';
import { BaseLayerOptions } from 'ol-layerswitcher';

@Component({
  selector: 'ngx-map-viewer',
  templateUrl: './map-viewer.component.html',
  styleUrls: ['./map-viewer.component.scss']
})
export class MapViewerComponent implements OnInit,AfterViewInit {

  private geometry: any;
  @Input()
  set loadGeometry(geom: any) {
    this.geometry = geom;
  }

  @ViewChild('geometrymapcontainer', {read: ElementRef})
  mapElement: ElementRef<HTMLElement>;

  map: Map;
  feature: Feature<Geometry>;
  vectorSource: VectorSource<Geometry>;


  parcelaStyle =  new Style({
    stroke: new Stroke({
      color: 'blue',
      width: 1,
    }),
    fill: new Fill({
      color: 'rgba(255, 255, 255, 0.50)',
    }),
  });

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.initMap();
    this.pintarParcela();

  }

  initMap() {

    this.vectorSource = new VectorSource();

    let projection = olProj.get('EPSG:3857');
    let projectionExtent = projection.getExtent();
    //var size = ol.extent.getWidth(projectionExtent) / 512;
    let size = olExtent.getWidth(projectionExtent) / 256;
    let resolutions = new Array(18);
    let matrixIds = new Array(18);
    for (var z = 0; z < 18; ++z) {
      // generate resolutions and matrixIds arrays for this WMTS
      resolutions[z] = size / Math.pow(2, z);
      //matrixIds[z] = "EPSG:4326:" + z;
      matrixIds[z] = z;
    }

    this.map = new Map({
      target: this.mapElement.nativeElement,
      controls:[],
      layers: [
        new TileLayer({
      source: new OSM(),
    }) ,
    new TileLayer(<BaseLayerOptions>{
      visible: true,
      title: 'Mapa PNOA',
      type:'base',
      source: new WMTS({
        attributions: ['Teselas de PNOA cedido por el Instituto Geográfico Nacional de España'],
        url: 'http://www.ign.es/wmts/pnoa-ma',
        layer: 'OI.OrthoimageCoverage',
        // matrixSet: 'EPSG:4326',
        matrixSet: 'EPSG:3857',
        format: 'image/png',
        projection: olProj.get('EPSG:3857'),

        tileGrid: new WMTSTileGrid({
          origin: olExtent.getTopLeft(olProj.get('EPSG:3857').getExtent()),
          resolutions: resolutions,
          matrixIds: matrixIds
        }),
        style: 'default',
      })
    }),
        new VectorLayer({
          source: this.vectorSource,
        }),
      ],
      view: new View({
        //center: olProj.fromLonLat(this.config.center),
        zoom: 5,
      })
    });

    console.log("Mapa inicializado")
  }



  pintarParcela(){
    if(this.geometry != null) {

      let geomcoords = JSON.parse(JSON.stringify(this.geometry.coordinates));
      geomcoords[0] = geomcoords[0].map(function(coordinate){
        return olProj.fromLonLat(coordinate);
      });

      let feature = new Feature({
        geometry: new Polygon(
          geomcoords),

      });

      feature.setStyle(this.parcelaStyle.clone());

      this.vectorSource.addFeature(feature);

      this.map.getView().fit(this.vectorSource.getExtent(),{padding:[10,10,10,10],nearest:true});
    }
  }

}



